module.exports = "/assets/data/da8d846d852da6f044391b997b4b79ad-MK7.data.json";